import {useEffect,useState} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import axios from 'axios'
import {useSelector, useDispatch} from 'react-redux';
import { ArrowDropDownCircleOutlined, Edit, ScoreOutlined } from '@mui/icons-material';
import {Button, CircularProgress, Snackbar, TablePagination} from '@mui/material';
import ContentView from '../Components/ContentView';
import { styled, alpha,useTheme } from '@mui/material/styles';
import UserInput from "../Components/UserInput"
import CardViewDialog from './CardViewDialog';
import MatchDialog from './MatchDialog';
import SendAcceptDialog from './SendAcceptDialog';
import { add_candidates, delete_candidates } from '../Redux/settingSlice';

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
  background:"#100101",
  maxHeight:400,
  minHeight:200
})
);

function Row(props) {

const { row,submitting,loading,setMessage,setOpen,setNewData } = props;
const [visible,setVisible] = useState(false)
const data = useSelector(state => state?.job.job);
const [change,setChange] = useState(false)
const dispatch = useDispatch()
const [showAccept,setShowAccept] = useState(false)
const [imageData,setImageData] = useState(row?.user?.cv)
const [title, setTitle] = useState("");
const [description, setDescription] = useState("");
const [showMatch,setShowMatch] = useState(false)
const [showModal,setShowModal] = useState(false)
const [isAccept,setIsAccept] = useState(false)
const [userData,setUserData] = useState(row)

return (
    <>
    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
        <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setVisible(!visible)}
        >
            {visible ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
        </TableCell>
        <TableCell align="left">{row?.email ? row?.email : "unknown"}</TableCell>
        <TableCell align="left">{row?.user?.first_name} { row?.user?.last_name}</TableCell>
        <TableCell align="left">{row?.user?.position ? row?.user?.position : "unknown"}</TableCell>
        <TableCell align="left">{row?.user?.nationality ? row?.user?.nationality : "unknown"}</TableCell>
        <TableCell align="left">
            <Button onClick={(e)=>{
                e?.preventDefault()
                setImageData(row?.cv)
                setShowModal(true)
            }} sx={{background:"#fff",color:"#000",margin:1,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                 View
            </Button>
        </TableCell>
        <TableCell align="left">
            <Button onClick={(e)=>{
                e?.preventDefault()
                setShowMatch(true)
            }}  sx={{background:"maroon",color:"white",margin:1,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                Match
            </Button>
        </TableCell>
    </TableRow>
    <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
        <Collapse in={visible} timeout="auto" unmountOnExit>
           <Box sx={{ margin: 1,width:"100%" }}>
                <Typography sx={{fontSize:12,fontFamily:"dinofans",color:"gold"}}>
                    Applicant Detail
                </Typography>
                <Box  display="flex" flexWrap="wrap" flexDirection="row" justifyContent="flex-start" alignItems="center">
                   {
                    row?.content?.map((item,index)=>(
                        <Box key={index} m={1} width="30%">
                            <Typography sx={{fontSize:12,fontFamily:"dinofans",color:"gray"}}>
                                Question
                            </Typography>
                            <Typography mb={1} sx={{fontSize:12,color:"$fff"}}>
                                {item?.question}
                            </Typography>
                            <Typography sx={{fontSize:12,fontFamily:"dinofans",color:"gray"}}>
                                Response
                            </Typography>
                            {
                                (item?.type === "Simple" || item?.type === "One")   && (
                                    <Box width={100} sx={{whiteSpace:"pre-wrap"}}>
                                        <Typography  mb={1} sx={{fontSize:12,whiteSpace:"stable"}}>
                                            {item?.response ? item?.response : "no response"}
                                        </Typography>
                                    </Box>
                                )
                            }
                            {
                                (item?.type === "Link")   && (
                                    <Box width={100} sx={{whiteSpace:"pre-wrap"}}>
                                        <a style={{color:"gold",textDecoration:"none",fontSize:12}} href={`${item?.responsek}`}>
                                            {item?.response ? item?.response : "unavailable"}
                                        </a>
                                    </Box>
                                )
                            }
                            {
                                (item?.type === "Image" || item?.type === "Files")   && (
                                    <Box width={100} sx={{whiteSpace:"pre-wrap"}}>
                                        <Button onClick={(e)=>{
                                            e?.preventDefault()
                                            setImageData(item?.response)
                                            setShowModal(true)
                                        }} sx={{background:"#fff",color:"#000",margin:1,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                                            View
                                        </Button>
                                    </Box>
                                )
                            }
                            {
                                (item?.type === "Multiple" )   && (
                                    <Box width={100} sx={{whiteSpace:"pre-wrap",textAlign:"left"}}>
                                        <ol>
                                            {
                                                item?.response?.map((itm,indx)=>(
                                                    <li style={{color:"#fff",fontSize:12}} key={indx}>
                                                        {itm}
                                                    </li>
                                                ))
                                            }
                                        </ol>
                                    </Box>
                                )
                            }
                        </Box>
                    ))
                   }
                </Box>
                <Box width="100%" sx={{textAlign:"right",display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
                    <Button onClick={async (e)=>{
                        e?.preventDefault()
                        setIsAccept(true)
                        setTitle(`Congratulation ${row?.user?.first_name} for been selected`)
                        setDescription(`Hello ${row?.user?.first_name}, we hope you are doing fine.we want to inform you that you have been selected on your submission in ${data?.title}.we will inform you later for next steps. ` )
                        setShowAccept(true)
                    }} disabled={row?.status === "accepted"} sx={{background:(row?.status === "accepted" ? "#000" :"#fff"),color:"#000",margin:1,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                        Accept
                    </Button>
                    <Button onClick={async (e)=>{
                        e?.preventDefault()
                        setIsAccept(false)
                        setTitle(`${data.title} application pre-selection`)
                        setDescription(`hello dear candidate, we hope you are doing fine. we would like to inform you about your submission for ${data?.title}, you have not been selected. we had many submissions and we hope you will do better next time. thank you.`)
                        setShowAccept(true)
                    }} disabled={row?.status === "rejected"} sx={{background:"maroon",color:"#fff",margin:1,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                        Reject
                    </Button>
                </Box>
            </Box>
        </Collapse>
        </TableCell>
    </TableRow>
    <SendAcceptDialog setDescription={setDescription} description={description} setTitle={setTitle} title={title} setNewData={setNewData} setMessage={setMessage} setOpen={setOpen} isAccepted={isAccept} visible={showAccept} setVisible={setShowAccept} candidate={row}/>
    <MatchDialog setNewData={setNewData} data={userData} visible={showMatch} setVisible={setShowMatch}/>
    <CardViewDialog visible={showModal} setVisible={setShowModal} data={imageData} title="CV of the applicant"/>
    </>
);
}

Row.propTypes = {
row: PropTypes.shape({
    email: PropTypes.string,
    user: PropTypes.arrayOf(
      PropTypes.shape({
        email: PropTypes.string.isRequired,
        first_name: PropTypes.string.isRequired,
        last_name: PropTypes.string.isRequired,
        nationality: PropTypes.string.isRequired,
        position: PropTypes.string.isRequired,
        
      }),
    ).isRequired
})
};

// const rows = [...newData];

export default function JobParticipants({filterData}) {

const theme = useTheme();
const data = useSelector(state => state?.job.job);
const user = useSelector(state => state?.auth.user);
const [submitting,setSubmitting] = useState(false)
const [loading,setLoading] = useState(false)
const [expanded, setExpanded] = useState(false);
const [visible,setVisible] = useState(false)
const [accepted,setAccepted] = useState(0)
const [message,setMessage] = useState('')
const dispatch = useDispatch()
const [newData,setNewData] = useState(data?.applicants || [])
const [order, setOrder] = useState('asc');
const [orderBy, setOrderBy] = useState('calories');
const [selected, setSelected] = useState([]);
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);


const handleChangePage = (event, newPage) => {
    setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event?.target?.value, 10));
    setPage(0);
};

const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - newData.length) : 0;

const handleSnackbarClose = ()=>{
    setVisible(false)
}

useEffect(()=>{
    setNewData(data?.applicants)
},[data])

useEffect(()=>{
    dispatch(delete_candidates())
},[])

return (
    <>
        <Snackbar 
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }} 
            message={message} 
            onClose={handleSnackbarClose} 
            open={visible} 
            autoHideDuration={2000}
        />
         {newData?.filter(item=>item?.status === filterData && item?.hasFinished)?.length == 0 && (
            <Box sx={{width:"100%",alignItems:"center",justifyContent:"center",flexDirection:"row",marginTop:2,display:"flex"}}>
                <Edit size={5} name="edit" sx={{color:"gold"}}/>
                <Typography sx={{color:"white",padding:1,fontSize:12}}>
                    There not yet any applicants
                </Typography>
            </Box>
            )
        }
        {newData?.filter(item=>item?.status === filterData && item?.hasFinished)?.length > 0 && (
            <>
            <TableContainer component={Paper} sx={{width:"95%",margin:1}}>
                <Table aria-label="collapsible table">
                    <TableHead>
                    <TableRow>
                        <TableCell/>
                        <TableCell>Email</TableCell>
                        <TableCell align="left">Full&nbsp;Name</TableCell>
                        <TableCell align="left">Position</TableCell>
                        <TableCell align="left">Nationality</TableCell>
                        <TableCell align="left">CV</TableCell>
                        <TableCell align="left">Filter</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {newData?.filter(item=>item?.status === filterData && item?.hasFinished)?.map((row,index) => (
                        <Row key={index} row={row} setNewData={setNewData} setMessage={setMessage} setOpen={setVisible} submitting={submitting} loading={loading}/>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer> 
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                labelRowsPerPage={<Typography sx={{fontSize:11,color:"#ff0"}}>
                                    applicant per page
                                </Typography>}
                count={newData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </>
            )}
    </>

);
}
